import { render, staticRenderFns } from "./QuotationNonProportional.vue?vue&type=template&id=47794e78&scoped=true&"
import script from "./QuotationNonProportional.vue?vue&type=script&lang=js&"
export * from "./QuotationNonProportional.vue?vue&type=script&lang=js&"
import style0 from "./QuotationNonProportional.vue?vue&type=style&index=0&id=47794e78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47794e78",
  null
  
)

export default component.exports